import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgApexchartsModule } from "ng-apexcharts";
import { CoreService } from "../../../services/core.service";
import { ChartComponent } from "ng-apexcharts";


@Component({
  selector: "app-social-ai-reach-chart",
  standalone: true,
  imports: [CommonModule, NgApexchartsModule],
  templateUrl: "./social-ai-reach-chart.component.html",
  styleUrls: ["./social-ai-reach-chart.component.scss"],
})
export class SocialAiReachChartComponent implements OnInit, OnChanges {

  @Input() selectedSiteId: number | null = null;
  @Input() selectedPlatformId: number | null = null;
  @Input() selectedPeriod: string | null = null;
  @Input() pages: any[] = [];
  @Input() title: string = "";
  @ViewChild("chartRef", { static: false })
  chart!: ChartComponent;

  metricValue = 0;
  metricDiff = 0;
  chartOptions: any = {};
  companyID: number | null = null;

  isLoaded = false;
  private lastPayloadKey: string | null = null;

  constructor(private coreService: CoreService) { }

  ngOnInit(): void {
    this.tryLoadData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.tryLoadData();
  }

  private tryLoadData(): void {
    if (
      !this.selectedSiteId ||
      !this.selectedPlatformId ||
      !this.selectedPeriod
      // !this.pages?.length
    ) {
      return;
    }

    const firstPage = this.pages[0] || {};

    const payloadKey = JSON.stringify({
      site: this.selectedSiteId,
      platform: this.selectedPlatformId,
      period: this.selectedPeriod,
      smid: firstPage.social_media_id,
      token: firstPage.access_token,
    });

    if (payloadKey === this.lastPayloadKey) return;
    this.lastPayloadKey = payloadKey;

    this.loadReachData();
  }

  loadReachData(): void {
    this.companyID = this.coreService.user?.companyID || 0;
    this.isLoaded = false;


    const payload = {
      content_site_id: this.selectedSiteId,
      social_platform_id: this.selectedPlatformId,
      period: this.selectedPeriod,
      pages: this.pages,
    };

    const selectedPlatform = this.pages?.[0];
    const platformName = (selectedPlatform?.platform || "").toLowerCase();

    const isInstagram =
      platformName.includes("instagram") ||
      platformName.includes("insta") ||
      platformName.includes("ig");

    const endpoint = isInstagram
      ? `querymetrics/parseInstaAnalytics/${this.companyID}?metric=reach`
      : `querymetrics/parseFbAnalytics/${this.companyID}?metric=page_total_media_view_unique`;

    this.coreService.postData(endpoint, payload).subscribe({
      next: (res) => {
        const meta = res.meta || res.original?.meta || {};

        /* ============================================================
         * INSTAGRAM
         * ============================================================*/
        if (isInstagram && meta.dailyValues?.length && meta.dates?.length) {

          let values = meta.dailyValues.map((val: number, i: number) => ({
            date: new Date(meta.dates[i].replace("+0000", "Z")),
            value: val
          }));

          values.forEach((v: any) => v.date.setDate(v.date.getDate() + 1));

          if (this.selectedPeriod === "week" && values.length > 7) {
            values = values.slice(values.length - 7);
          }

          const categories = values.map((v: any) =>
            v.date.toLocaleDateString("el-GR", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric"
            })
          );

          this.metricValue = values.at(-1)?.value || 0;
          this.metricDiff = this.metricValue - (values[0]?.value || 0);

          this.chartOptions = {
            series: [{ name: "Reach", data: values.map((v: any) => v.value) }],
            chart: { type: "area", height: 360, toolbar: { show: false } },
            stroke: { curve: "smooth", width: 2, colors: ["#6ab7ff"] },
            dataLabels: { enabled: false },
            grid: {
              borderColor: "#f1f3f4",
              strokeDashArray: 0,
              yaxis: { lines: { show: true } },
              xaxis: { lines: { show: false } },
            },
            yaxis: {
              tickAmount: 6,
              labels: {
                style: { colors: "#777", fontSize: "12px" },
                formatter: (val: number, index: number) =>
                  index === 0 ? "" : val.toLocaleString(),
              },
            },
            xaxis: {
              categories,
              tickAmount: 6,
              labels: { style: { colors: "#777", fontSize: "12px" } },
            },
            tooltip: {
              theme: "light",
              y: { formatter: (val: number) => val.toLocaleString("el-GR") },
            },
            legend: {
              show: true,
              position: "bottom",
              horizontalAlign: "center",
              labels: { colors: "#888" },
            },
            title: {
              align: "left",
              style: {
                fontSize: "15px",
                fontWeight: "600",
                color: "#333",
              },
            },
          };

          this.isLoaded = true;
          return;
        }

        /* ============================================================
         * FACEBOOK
         * ============================================================*/
        const data =
          res.data?.[0]?.insight?.data?.[0]?.values || [];

        const values = data.map((v: any) => ({
          date: new Date(v.end_time),
          value: v.value,
        }));

        if (this.selectedPeriod === "week" && values.length > 7) {
          values.splice(0, values.length - 7);
        }

        this.metricValue = values.at(-1)?.value || 0;
        this.metricDiff = this.metricValue - (values[0]?.value || 0);

        const categories = values.map((v: any) =>
          v.date.toLocaleDateString("el-GR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
          })
        );

        this.chartOptions = {
          series: [{ name: "Reach", data: values.map((v: any) => v.value) }],
          chart: { type: "area", height: 360, toolbar: { show: false } },
          stroke: { curve: "smooth", width: 2, colors: ["#6ab7ff"] },
          dataLabels: { enabled: false },
          grid: {
            borderColor: "#f1f3f4",
            strokeDashArray: 0,
            yaxis: { lines: { show: true } },
            xaxis: { lines: { show: false } },
          },
          yaxis: {
            tickAmount: 6,
            labels: {
              style: { colors: "#777", fontSize: "12px" },
              formatter: (val: number, index: number) =>
                index === 0 ? "" : val.toLocaleString(),
            },
          },
          xaxis: {
            categories,
            tickAmount: 6,
            labels: { style: { colors: "#777", fontSize: "12px" } },
          },
          tooltip: {
            theme: "light",
            y: { formatter: (val: number) => val.toLocaleString("el-GR") },
          },
          legend: {
            show: true,
            position: "bottom",
            horizontalAlign: "center",
            labels: { colors: "#888" },
          },
          title: {
            align: "left",
            style: {
              fontSize: "15px",
              fontWeight: "600",
              color: "#333",
            },
          },
        };
      },

      complete: () => {
        this.isLoaded = true;
      },
    });
  }

  async exportChartImage(): Promise<string> {

    if (!this.chart) {
      throw new Error('Reach chart not ready');
    }

    const data = await this.chart.dataURI();
    return data.imgURI;
  }

}
